import { THEME_CONTENT_IMPORTANT_PRIORITY } from '../../../../constants/themeMode'
import {
  getDarkContentHtml,
  getThemeContentCorrectionKey,
  getThemeContentCorrections,
  getThemeContentKeptColorKeys,
  restoreThemeContentHtml,
} from '../../../../utils/themeContent'
import { isThemeDark } from '../../../../utils/themeMode'
import {
  WYSIWYG_EDITOR_EVENT_BEFORE_SET_CONTENT,
  WYSIWYG_EDITOR_EVENT_EXEC_COMMAND,
  WYSIWYG_EDITOR_EVENT_GET_CONTENT,
} from '../../WysiwygEditor.constants'

import { isEditorThemeContentTextColorCommand } from './useEditorThemeContent.utils'

export function useEditorThemeContent({ theme }) {
  function setup(editor) {
    if (isThemeDark(theme)) {
      const corrections = new Map()
      // A color the user picks or the sender declared stays theirs, even when it equals a corrected one
      const keptColorKeys = new Set()

      editor.on(WYSIWYG_EDITOR_EVENT_BEFORE_SET_CONTENT, event => {
        event.content = getDarkContentHtml(event.content, {
          priority: THEME_CONTENT_IMPORTANT_PRIORITY,
        })

        getThemeContentKeptColorKeys(event.content).forEach(key => {
          keptColorKeys.add(key)
          corrections.delete(key)
        })

        getThemeContentCorrections(event.content).forEach((original, key) => {
          if (!keptColorKeys.has(key)) {
            corrections.set(key, original)
          }
        })
      })

      editor.on(WYSIWYG_EDITOR_EVENT_EXEC_COMMAND, event => {
        if (isEditorThemeContentTextColorCommand(event)) {
          const key = getThemeContentCorrectionKey('color', event.value)

          keptColorKeys.add(key)
          corrections.delete(key)
        }
      })

      editor.on(WYSIWYG_EDITOR_EVENT_GET_CONTENT, event => {
        event.content = restoreThemeContentHtml(event.content, corrections)
      })
    }
  }

  return {
    setup,
  }
}
